import { FormattedMessage, useIntl } from "react-intl";
import { Box, SelectChangeEvent, Typography } from "@mui/material";

import { RevbellSelect } from "../../../components/Inputs/RevbellSelect";
import { CriticityType } from "../../interfaces";
import { memo } from "react";

const Options: { value: CriticityType; label: JSX.Element }[] = [
  {
    value: 0,
    label: (
      <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
        <Box
          sx={{
            width: "20px",
            height: "20px",
            backgroundColor: "error.main",
            borderRadius: "4px",
          }}
        />
        <Typography>
          <FormattedMessage id="BANNER_CRITICITY_HIGHEST" />
        </Typography>
      </Box>
    ),
  },
  {
    value: 1,
    label: (
      <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
        <Box
          sx={{
            width: "20px",
            height: "20px",
            backgroundColor: "warning.main",
            borderRadius: "4px",
          }}
        />
        <Typography>
          <FormattedMessage id="BANNER_CRITICITY_HIGH" />
        </Typography>
      </Box>
    ),
  },
  {
    value: 2,
    label: (
      <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
        <Box
          sx={(theme) => ({
            width: "20px",
            height: "20px",
            background: theme.vars.palette.nancie.gradient,
            borderRadius: "4px",
          })}
        />
        <Typography>
          <FormattedMessage id="BANNER_CRITICITY_MEDIUM" />
        </Typography>
      </Box>
    ),
  },
  {
    value: 3,
    label: (
      <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
        <Box
          sx={{
            width: "20px",
            height: "20px",
            backgroundColor: "success.main",
            borderRadius: "4px",
          }}
        />
        <Typography>
          <FormattedMessage id="BANNER_CRITICITY_LOW" />
        </Typography>
      </Box>
    ),
  },
];

const BannerColorSelector = memo(
  ({
    defaultValue,
    error,
    onCriticityChange,
  }: {
    defaultValue?: CriticityType;
    error?: string;
    onCriticityChange: (contents: CriticityType) => void;
  }) => {
    const intl = useIntl();

    const handleChange = (event: SelectChangeEvent<unknown>) => {
      const value = event.target.value as CriticityType;
      onCriticityChange(value);
    };

    return (
      <Box>
        <RevbellSelect
          defaultValue={defaultValue ?? ""}
          fullWidth
          label={intl.formatMessage({ id: "BANNER_CRITICITY_SELECTOR" })}
          options={Options}
          onChange={handleChange}
          formControlSx={{ width: "100%" }}
          sx={{
            borderRadius: "4px !important",
            width: "100%",
            "& .MuiSelect-select": { padding: "6px 39px 6px 6px" },
          }}
        />
        {error && (
          <Typography
            sx={{
              color: "error.main",
              fontSize: "0.75rem",
              ml: 1.75,
            }}
          >
            <FormattedMessage id={error} />
          </Typography>
        )}
      </Box>
    );
  }
);

export default BannerColorSelector;
